import * as API from '../api'
import * as formatContentToSend from '../utils/formatContentToSend'
import * as formatReferenceToSelect from '../utils/formatReferenceToSelect'
export const FETCH_CONTENT = 'FETCH_CONTENT'
export const FETCHING_CONTENT = 'FETCHING_CONTENT'
export const FETCH_CONTENT_ERROR = 'FETCH_CONTENT_ERROR'
export const FETCH_CONTENTS = 'FETCH_CONTENTS'
export const FETCHING_CONTENTS = 'FETCHING_CONTENTS'
export const FETCH_CONTENTS_ERROR = 'FETCH_CONTENTS_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_CONTENT = 'CHANGE_CONTENT'
export const DELETE_CONTENT = 'DELETE_CONTENT'
export const ADD_CONTENT = 'ADD_CONTENT'
export const EDIT_CONTENT = 'EDIT_CONTENT'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_CONTENT = 'NEW_FORM_CONTENT'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CONTENT_FORM_ERROR = 'CONTENT_FORM_ERROR'
export const FETCHING_HTML_PREVIEW = 'FETCHING_HTML_PREVIEW'
export const FETCH_HTML_PREVIEW = 'FETCH_HTML_PREVIEW'
export const FETCH_HTML_PREVIEW_ERROR = 'FETCH_HTML_PREVIEW_ERROR'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const OPEN_LOGS_MODAL = 'OPEN_LOGS_MODAL'
export const CLOSE_LOGS_MODAL = 'CLOSE_LOGS_MODAL'
export const FETCHING_LOGS = 'FETCHING_LOGS'
export const FETCH_LOGS = 'FETCH_LOGS'
export const FETCH_LOGS_ERROR = 'FETCH_LOGS_ERROR'
export const RESET_STATE = 'RESET_STATE'
export const REMOVE_CONTENT_DOCUMENT = 'REMOVE_CONTENT_DOCUMENT'
export const OPEN_EDIT_DOCUMENT_MODAL = 'OPEN_EDIT_DOCUMENT_MODAL'
export const CLOSE_EDIT_DOCUMENT_MODAL = 'CLOSE_EDIT_DOCUMENT_MODAL'
export const CHANGE_REFERENCE = 'CHANGE_REFERENCE'
export const CHANGE_JOB_STATUS = 'CHANGE_JOB_STATUS'
export const CHANGE_BUSCA_CONTENT = 'CHANGE_BUSCA_CONTENT'
export const CLEAR_BUSCA_PESO = 'CLEAR_BUSCA_PESO'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const openLogsModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_LOGS_MODAL })
  }
}

export const closeLogsModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_LOGS_MODAL })
  }
}

export const openEditDocumentModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_EDIT_DOCUMENT_MODAL })
  }
}

export const closeEditDocumentModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_EDIT_DOCUMENT_MODAL })
  }
}

export const handleChangeContent = content => {
  return dispatch => {
    dispatch({ type: CHANGE_CONTENT, content })
  }
}

export const handleChangeBuscaContent = keyword => {
  return dispatch => {
    dispatch({ type: CHANGE_BUSCA_CONTENT, keyword })
  }
}

const getApiResource = type => {
  switch (true) {
    case ['curso', 'livro'].includes(type):
      return {
        name: 'preRegistrations',
        method: 'getPreRegistration'
      }
    case ['capitulo'].includes(type):
      return {
        name: 'content',
        method: 'getContent'
      }
    case ['artigo'].includes(type):
      return {
        name: 'content',
        method: 'getContent'
      }
    case ['diagnostico_e_tratamento'].includes(type):
      return {
        name: 'content',
        method: 'getContent'
      }
    default:
      return {}
  }
}

export const handleChangeReference = ({ refType, reference }) => {
  const apiResource = getApiResource(refType)
  const method = (API[apiResource.name] || {})[apiResource.method]

  return dispatch => {
    if (!reference || !method) {
      const data = {}
      return dispatch({ type: CHANGE_REFERENCE, refType, reference, data })
    }

    method((reference || {}).value)
      .then(({ data }) => {
        dispatch({ type: CHANGE_REFERENCE, refType, reference, data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_CONTENT_ERROR,
          err: message || 'Serviço indisponível'
        })

        handleContentError(response, dispatch)

        return Promise.reject(response)
      })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_[0-9]{1,2}/.exec(errorMessage) // eslint-disable-line
  return field
}

const getInvalidField = errorMessage => {
  const [x, field = ''] = /validation failed: (.*):/.exec(errorMessage) || [] // eslint-disable-line
  return field
}

export const handleContentError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: CONTENT_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    case errorMessage.includes('validation failed'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: CONTENT_FORM_ERROR,
        field: getInvalidField(errorMessage),
        message: `${getInvalidField(errorMessage)} é inválido.`
      })
      return Promise.reject(res)

    default:
      return Promise.reject(res)
  }
}

export const newFormContent = content => {
  return dispatch => {
    dispatch({ type: NEW_FORM_CONTENT })
  }
}

export const setContentFormTouched = content => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreContent = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CONTENTS })
    return API.content
      .restoreContent(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_CONTENT, content: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CONTENTS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleContentError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchContents = options => {
  return dispatch => {
    dispatch({ type: FETCHING_CONTENTS })
    return API.content
      .getContents(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_CONTENTS,
          contents: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CONTENTS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteContent = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CONTENTS })
    return API.content
      .deleteContent(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_CONTENT, content: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CONTENTS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const addContent = content => {
  if (content.buscaPalavrasChave.length <= 0) {
    delete content.buscaPalavrasChave
    delete content.buscaPeso
  }

  const data = formatContentToSend.createFormData(content)
  return dispatch => {
    dispatch({ type: FETCHING_CONTENTS })
    dispatch({ type: FETCHING_CONTENT })
    return API.content
      .addContent(data)
      .then(({ data }) => {
        dispatch({ type: ADD_CONTENT, content: data })
        return data
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleContentError(response, dispatch)
        dispatch({
          type: FETCH_CONTENTS_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const getHtmlPreview = content => {
  const data = formatContentToSend.createFormData(content, { preview: true })
  return dispatch => {
    dispatch({ type: FETCHING_HTML_PREVIEW })
    return API.content
      .getHtmlPreview(data)
      .then(response => {
        const { data } = response
        dispatch({ type: FETCH_HTML_PREVIEW, conteudoHtml: data.htmlPreview })
        return response
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleContentError(response, dispatch)
        dispatch({
          type: FETCH_HTML_PREVIEW_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const removeHtmlDocument = () => {
  return dispatch => {
    dispatch({ type: REMOVE_CONTENT_DOCUMENT })
  }
}

export const editContent = content => {
  const { _id = '' } = content
  const data = formatContentToSend.createFormData(content)

  return dispatch => {
    dispatch({ type: FETCHING_CONTENTS })
    dispatch({ type: FETCHING_CONTENT })
    return API.content
      .editContent(data, _id)
      .then(({ data }) => {
        dispatch({ type: EDIT_CONTENT, content: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CONTENTS_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleContentError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchContent = id => {
  return dispatch => {
    dispatch({ type: FETCHING_CONTENT, clear: true })
    return API.content
      .getContent(id)
      .then(({ data }) => {
        const content = formatReferenceToSelect.handleReferences(data)
        dispatch({ type: FETCH_CONTENT, content })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CONTENT_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const fetchLogs = id => {
  return dispatch => {
    dispatch({ type: FETCHING_LOGS })
    return API.content
      .getLogs(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_LOGS, logs: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_CONTENT_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const reindexContents = () => {
  return dispatch => {
    return API.content.reindex().then(() => {
      dispatch({ type: CHANGE_JOB_STATUS, jobStatus: 'emAndamento' })
    })
  }
}

export const getStatusContentReindex = () => {
  return async dispatch => {
    try {
      const response = await API.content.checkStatusJob()
      const { data } = response
      const jobStatus = data.status

      dispatch({ type: CHANGE_JOB_STATUS, jobStatus })
      return jobStatus
    } catch (error) {
      const jobStatus = null
      dispatch({ type: CHANGE_JOB_STATUS, jobStatus })
      return jobStatus
    }
  }
}

export const clearBuscaPeso = () => {
  return dispatch => {
    dispatch({ type: CLEAR_BUSCA_PESO })
  }
}



// WEBPACK FOOTER //
// ./src/actions/content.js